// Coral observation banner — shows above ribbon when bedtime prediction has
// drifted ≥10 min from the morning baseline.

import { IconSparkle } from "./icons";
import { useT } from "../lib/LocaleContext";

type Props = {
  title: string;
  body: string;
  /** When set, shows a "×" that hides the banner for the rest of the day. */
  onDismiss?: () => void;
};

export function DriftBanner({ title, body, onDismiss }: Props) {
  const t = useT();
  return (
    <div style={styles.banner}>
      <div style={styles.icon}>
        <IconSparkle size={14} />
      </div>
      <div style={styles.body}>
        <div style={styles.title}>{title}</div>
        <div style={styles.text}>{body}</div>
      </div>
      {onDismiss && (
        <button
          style={styles.dismiss}
          onClick={onDismiss}
          aria-label={t.driftBanner.dismiss}
        >
          ×
        </button>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  banner: {
    margin: "0 14px 14px",
    padding: "12px 14px",
    background: "var(--bh-attn-soft)",
    borderRadius: 16,
    display: "flex",
    gap: 10,
    alignItems: "flex-start",
    border: "1px solid color-mix(in oklch, var(--bh-attn) 40%, transparent)",
  },
  icon: { color: "var(--bh-attn)", marginTop: 2 },
  body: { flex: 1 },
  title: { fontSize: 14, fontWeight: 600, color: "var(--bh-ink)" },
  text: { fontSize: 13, color: "var(--bh-ink-2)", marginTop: 2, lineHeight: 1.4 },
  dismiss: {
    appearance: "none",
    background: "transparent",
    border: "none",
    color: "var(--bh-ink-2)",
    fontSize: 22,
    lineHeight: 1,
    padding: "0 2px",
    marginTop: -2,
    marginLeft: 4,
    cursor: "pointer",
    // Generous tap target without bloating the row.
    minWidth: 28,
    minHeight: 28,
    flexShrink: 0,
  },
};
